import { FLIGHTS_HUB } from '../../constants';
import formatAirlinesAutocompleteResults from '../../helpers/formatters/formatAirlinesAutocompleteResults';
import getFiltersForSlider from '../../helpers/formatters/getFiltersForSlider';
import flightSearchInput from '../../helpers/selectors/flightSearchInput';
import { flightSearch, updateFlightSearchObj } from '../slices/flight';
import { setFilters, setFlightTripSearchInputs, setFlightTripSearchParam } from '../slices/tripSearch';

const onFlightsUpdated = (store,
  connections, handleRemoveConnection) => (res) => {
  if (!res.hasNoResults || res.searchProgress === 100) {
    const {
      defaultSearchObj, requestId, hasUserInteractedWithFlightList,
    } = flightSearchInput(res.tripId, !res.tripId)(store.getState());
    if (res.tripId) {
      if (requestId === res.requestId) {
        if (!res.hasNoResults) {
          if (hasUserInteractedWithFlightList) {
            store.dispatch(updateFlightSearchObj({
              tripId: res.tripId,
              searchProgress: res.searchProgress,
              foundTotalFlights: res.flightsCount,
            }));
          } else {
            store.dispatch(flightSearch({
              tripId: res.tripId,
              doIgnoreStoredResults: true,
              searchProgress: res.searchProgress,
            }));
          }
        }
        if (res.searchProgress === 100) {
          setTimeout(() => {
            store.dispatch(updateFlightSearchObj({
              tripId: res.tripId,
              searchProgress: null,
            }));
          }, 8000);
        }
      }
    } else if (res.requestId === requestId) {
      if (!res.hasNoResults) {
        if (hasUserInteractedWithFlightList) {
          store.dispatch(setFlightTripSearchParam({
            searchProgress: res.searchProgress,
            foundTotalFlights: res.flightsCount,
          }));
        } else {
          store.dispatch(flightSearch({
            doIgnoreStoredResults: true,
            searchProgress: res.searchProgress,
            isTripSearch: true,
          }));
        }

        if (res.filters) {
          store.dispatch(setFlightTripSearchInputs({
            airlinesAutocompleteResults: formatAirlinesAutocompleteResults(res.filters),
            ...getFiltersForSlider(res.filters, 'filterTakeoff', 'filterLanding'),
            defaultSearchObj: {
              ...defaultSearchObj,
              ...getFiltersForSlider(res.filters),
            },
          }));

          store.dispatch(setFlightTripSearchParam({
            ...getFiltersForSlider(res.filters, 'filterTakeoff', 'filterLanding'),
          }));

          store.dispatch(setFilters({ filters: res.filters }));
        }
      }
      if (res.searchProgress === 100) {
        if (connections[FLIGHTS_HUB] && connections[FLIGHTS_HUB].stop) {
          connections[FLIGHTS_HUB].stop().then(() => {
            console.log('Results received - connection closed');
            if (handleRemoveConnection) {
              handleRemoveConnection(FLIGHTS_HUB);
            }
          });
        }
        setTimeout(() => {
          store.dispatch(setFlightTripSearchParam({
            searchProgress: undefined,
          }));
        }, 8000);
      }
    }
  }
  console.log(res);
};

export default onFlightsUpdated;
